import { render } from "./inventorysubcategory.vue?vue&type=template&id=4597a34c"
import script from "./inventorysubcategory.vue?vue&type=script&lang=js"
export * from "./inventorysubcategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__